import { Outlet } from 'react-router-dom';
import { usePublicSurface } from '@/hooks/usePublicSurface';

/* One wrapper around every public marketing route.
   Why it exists: the marketing site keeps its own violet brand and its own
   type, but it lives in the same React tree as the ATS and was inheriting the
   ATS light-theme text classes onto its dark panels. `.mkt-scope` in index.css
   remaps those in ONE place (and clips the decorative orbs that were causing a
   sideways scroll at 390px). Nothing here themes the site — it scopes it. */
export default function MarketingScope() {
  /* The public site is NEVER themed. ThemeContext defaults every visitor —
     including an anonymous candidate — to the light 'daylight' group, and the
     Daylight accent sweep is scoped to `[role="dialog"]` so it reaches Radix
     portals. That repainted the public apply modal in the ATS teal and turned
     its panels pale. `data-public` on <html> excludes every themed rule while a
     public route is mounted. */
  usePublicSurface();

  return (
    <div className="mkt-scope" data-testid="marketing-scope">
      <Outlet />
    </div>
  );
}
